import { Box, Button, Skeleton, Typography } from "@mui/material";
import { NodeViewWrapper, NodeViewProps } from "@tiptap/react";
import React from "react";

export const UnlockCardComponent: React.FC<NodeViewProps> = ({
  node,
  updateAttributes,
  deleteNode,
}) => {
  const { isOptimizedMode } = node.attrs;

  const handleUnlockClick = () => {
    // Dispatch custom event that the parent component can listen to
    const unlockEvent = new CustomEvent("unlockArticle", {
      detail: { isOptimizedMode },
      bubbles: true,
    });
    document.dispatchEvent(unlockEvent);
  };

  return (
    <NodeViewWrapper
      className="unlock-card-wrapper"
      style={{
        margin: "20px 0",
        position: "relative",
      }}
    >
      <Box
        sx={{
          // Hide ProseMirror paragraph indicators within this component
          "& p::before": {
            display: "none !important",
          },
          "& .ProseMirror p::before": {
            display: "none !important",
          },
        }}
      >
        {/* Skeleton Loading Lines */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mb: 3 }}>
        <Skeleton
          variant="text"
          height={20}
          width="100%"
          animation={false}
          sx={{ bgcolor: "#f0f0f0", borderRadius: "4px" }}
        />
        <Skeleton
          variant="text"
          height={20}
          width="100%"
          animation={false}
          sx={{ bgcolor: "#f0f0f0", borderRadius: "4px" }}
        />
        <Skeleton
          variant="text"
          height={20}
          width="100%"
          animation={false}
          sx={{ bgcolor: "#f0f0f0", borderRadius: "4px" }}
        />
        <Skeleton
          variant="text"
          height={20}
          width="100%"
          animation={false}
          sx={{ bgcolor: "#f0f0f0", borderRadius: "4px" }}
        />
        <Skeleton
          variant="text"
          height={15}
          width="65%"
          animation={false}
          sx={{ bgcolor: "#f0f0f0", borderRadius: "4px" }}
        />
      </Box>

      {/* Unlock Card */}
      <Box
        sx={{
          color: "rgb(18, 24, 40)",
          backgroundImage: "none",
          width: "100%",
          height: "auto",
          display: "flex",
          alignItems: "center",
          backgroundColor: "rgb(80, 72, 229)",
          boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 10px 0px",
          transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1)",
          overflow: "hidden",
          borderRadius: "10px",
          padding: "10px 16px",
          justifyContent: "space-between",
          flexDirection: { xs: "column", md: "row" },
          gap: 2,
        }}
      >
        <Box sx={{ flex: 1, textAlign: { xs: "center", md: "left" } }}>
          <Typography
            sx={{
              fontSize: "14px",
              fontFamily: "Inter, sans-serif",
              fontWeight: 600,
              color: "#fff",
              mb: "0px !important",
              // position: "relative",
              // zIndex: 1,
            }}
          >
            Your {isOptimizedMode ? "optimized " : ""}content is ready
          </Typography>

          <Typography
            sx={{
              fontSize: "16px",
              fontFamily: "Inter, sans-serif",
              fontWeight: 600,
              color: "#fff",
              mb: "0px !important",
              // position: "relative",
              // zIndex: 1,
            }}
          >
            Subscribe to see the full article
          </Typography>
        </Box>

        <Button
          variant="contained"
          onClick={handleUnlockClick}
          sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            boxSizing: "border-box",
            cursor: "pointer",
            userSelect: "none",
            verticalAlign: "middle",
            appearance: "none",
            lineHeight: 1.75,
            minWidth: "64px",
            boxShadow: "none",
            textTransform: "none",
            fontSize: "14px",
            fontFamily: "Inter",
            fontWeight: 600,
            color: "rgb(255, 255, 255)",
            width: "150px",
            height: "49px",
            outline: "0px",
            border: "0px",
            margin: "0px",
            textDecoration: "none",
            transition:
              "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1), box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1), border-color 250ms cubic-bezier(0.4, 0, 0.2, 1), color 250ms cubic-bezier(0.4, 0, 0.2, 1)",
            padding: "8px 16px",
            borderRadius: "8px",
            background: "rgb(235, 31, 141) !important",
            "&:hover": {
              background: "rgb(235, 31, 141) !important",
            },
          }}
        >
          Unlock Now
        </Button>
        </Box>
      </Box>
    </NodeViewWrapper>
  );
};
